// components/PriceDetails.js
import React from 'react';

const PriceDetails = ({
    formData,
    errors,
    listingTypeSelectedFields,
    propertyTypeSelectedFields,
    handleInputChange
}) => {
    return (
        <>
            <div className="mb-3 col-lg-4 col-md-6">
                <label className="form-label">Property Price</label>
                <input
                    type="text"
                    className={`form-control ${errors.price ? 'is-invalid' : ''}`}
                    value={formData.price}
                    onChange={(e) => handleInputChange('price', e.target.value)}
                />
                {errors.price && <div className="invalid-feedback">{errors.price}</div>}
            </div>

            <div className="mb-3 col-12">
                <div className="form-check form-check-inline">
                    <input
                        type="checkbox"
                        className="form-check-input"
                        checked={formData.isNegotiable}
                        onChange={(e) => handleInputChange('isNegotiable', e.target.checked)}
                    />
                    <label className="form-check-label">Price Negotiable</label>
                </div>

                {listingTypeSelectedFields.includes("loanEligible") && (
                    <div className="form-check form-check-inline">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            checked={formData.loanEligible}
                            onChange={(e) => handleInputChange('loanEligible', e.target.checked)}
                        />
                        <label className="form-check-label">Loan Eligible</label>
                    </div>
                )}

                {listingTypeSelectedFields.includes("bachelersAllowed") && (
                    <div className="form-check form-check-inline">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            checked={formData.bachelorsAllowed}
                            onChange={(e) => handleInputChange('bachelorsAllowed', e.target.checked)}
                        />
                        <label className="form-check-label">Bachelors Allowed</label>
                    </div>
                )}

                {propertyTypeSelectedFields.includes("reraApproved") && (
                    <div className="form-check form-check-inline">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            checked={formData.reraApproved}
                            onChange={(e) => handleInputChange('reraApproved', e.target.checked)}
                        />
                        <label className="form-check-label">RERA Approved</label>
                    </div>
                )}
            </div>

            {propertyTypeSelectedFields.includes("reraId") && (
                <div className="mb-3 col-lg-4 col-md-6">
                    <label className="form-label">RERA ID</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="RERA ID"
                        value={formData.reraId}
                        onChange={(e) => handleInputChange('reraId', e.target.value)}
                    />
                </div>
            )}
        </>
    );
};

export default PriceDetails;
